import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { CmsLinkComponent } from '../../../core/model';

@Component({
  selector: 'py-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkComponent implements OnInit, OnDestroy {
  private _hostClassOptions: string[] = ['text-center', 'text-right', 'text-left'];
  protected _subscriptions = new Subscription();

  @HostBinding('class') hostStyleClasses: string = '';

  styleClasses: string = '';
  data: CmsLinkComponent;

  constructor(
    public component: CmsComponentData<CmsLinkComponent>,
    private cd: ChangeDetectorRef
  ) {}

  /**
   * Adds appropirate styling classes to host, text-center e.g..
   * Other classes from CMS will be set to link element.
   */
  ngOnInit(): void {
    this._subscriptions.add(
      this.component.data$.subscribe((data) => {
        if (data?.styleClasses?.split) {
          for (let el of data.styleClasses?.split(' ')) {
            el = el.replace('cta-', '');
            this._hostClassOptions.includes(el) ? (this.hostStyleClasses += `${el} `) : (this.styleClasses += `${el} `);
          }
        }
        this.data = data;
        this.cd.detectChanges();
      })
    );
  }

  hasClass(className: string): boolean {
    return !!this.styleClasses.split(' ').find((name) => name === className);
  }

  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.target` flag is set to `true`.
   */
  getTarget(data: CmsLinkComponent): string | null {
    return data.target === 'true' || data.target === true ? '_blank' : null;
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
